import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-25 10:29:18
 * @LastEditTime: 2022-01-13 19:02:48
 * @LastEditors: wangshengqiang
 * @Description: 单选组件
 */
import React from 'react';
import { FormItem, Select } from '@/baseComponents';
export default function RowSelect(props) {
  const {
    remark = {},
    label,
    valueMember = 'value',
    textMember = 'label',
    displayRender,
    dataSource,
    attrs,
    formKey,
    rules,
    isRequired,
    isPremiumFactor,
    isBenefitFactor,
    // defaultValue,
    defaultInitialValue,
    cols = 1
  } = props;
  const {
    display = {}
  } = attrs;
  const {
    placeholder
  } = display;

  const _dataSource = dataSource || attrs.dataSource;

  let datas = _dataSource && _dataSource.filter(item => item.isDefault !== false);

  datas = datas.map(item => {
    item.value = String(item.value); // 全部转成字符串防止类型不对导致的不回显

    return item;
  });

  const defaultDisplayRender = selected => {
    return selected.map(item => item[textMember]).join('/');
  };

  const itemRender = item => {
    return item[textMember];
  };

  let initialValue;

  if (defaultInitialValue !== undefined) {
    initialValue = defaultInitialValue;
  } else {
    initialValue = display !== null && display !== void 0 && display.defaultValue && JSON.parse(display === null || display === void 0 ? void 0 : display.defaultValue) ? JSON.parse(display === null || display === void 0 ? void 0 : display.defaultValue) : undefined;
  }

  const finalRules = Array.isArray(rules) && rules.length > 0 ? rules.map(item => _objectSpread(_objectSpread({}, item), {}, {
    required: isRequired
  })) : [{
    required: isRequired,
    message: '请选择'
  }];
  const formItemProps = {
    name: formKey,
    fieldOption: {
      initialValue,
      rules: finalRules,
      isPremiumFactor,
      isBenefitFactor
    },
    label,
    remark
  };
  return /*#__PURE__*/React.createElement(FormItem, _extends({}, props, formItemProps), /*#__PURE__*/React.createElement(Select, {
    placeholder: placeholder,
    dataSource: datas,
    valueMember: valueMember,
    itemRender: itemRender,
    displayRender: displayRender || defaultDisplayRender,
    cols: cols
  }));
}